<div [ngClass]="['skeleton-loader', 'skeleton-loader_' + usage, customClass]"></div>
